import type { Company } from '../../data/companies';
import styles from './CompanyCard.module.css';

interface Props {
  company: Company;
}

export default function CompanyCard({ company }: Props) {
  return (
    <div className={styles.card}>
      <div className={styles.cardHeader}>
        <div className={styles.cardMeta}>
          <span className={styles.industry}>{company.industry}</span>
          <h3 className={styles.name}>{company.name}</h3>
          <span className={styles.tagline}>{company.tagline}</span>
        </div>
        <a
          href={company.link}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.externalLink}
          aria-label={`Open ${company.name}`}
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
            <polyline points="15 3 21 3 21 9" />
            <line x1="10" y1="14" x2="21" y2="3" />
          </svg>
        </a>
      </div>

      <p className={styles.description}>{company.description}</p>

      <div className={styles.footer}>
        <a
          href={company.link}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.visitLink}
        >
          Visit website
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <line x1="5" y1="12" x2="19" y2="12" />
            <polyline points="12 5 19 12 12 19" />
          </svg>
        </a>
        <span className={styles.dot} aria-hidden="true" />
      </div>
    </div>
  );
}
